var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("\n        Resumo das Cobranças\n    ")]),_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items},scopedSlots:_vm._u([{key:"item.description",fn:function(ref){
var item = ref.item;
return [_c('a',{on:{"click":function($event){return _vm.$router.push(item.to)}}},[_vm._v(_vm._s(item.description))])]}}],null,true)})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }